import React, { useEffect } from "react";
import "./Husman.css";

import Dator1 from "../../assets/SvenskHusmandator.png";
import Dator2 from "../../assets/Svenskhusmandator2.png";
import Mockup1 from "../../assets/husman.png";
import Mockup7 from "../../assets/husmanT.png";
import Mockup2 from "../../assets/husman3.png";
import Mockup3 from "../../assets/husman2.png";
import Mockup4 from "../../assets/Träd_utan_snö.png";
import Mockup5 from "../../assets/lusse.png";
import Mockup6 from "../../assets/husman4.jpg";

function useScrollReveal() {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}

export default function Husman() {
  useScrollReveal();

  return (
    <main className="project-page">

      {/* 🔥 Bakgrunds-lussebulle */}
      <div className="husman-bg-bun"></div>

      {/* ================= HERO ================= */}
      <section className="hero reveal">
        <div className="hero-copy">
          <p className="hero-kicker">Gamified campaign · Client: Svensk Husman</p>

          <h1 className="hero-title">
            The game where you can win prizes
            <span className="hero-title-accent"> from Svensk Husman</span>
          </h1>

          <p className="hero-body">
            Svensk Husman celebrates Swedish food culture through playful, colorful
            designs inspired by fika classics and local traditions. What began with
            a handful of sock patterns has grown into a joyful brand that turns
            nostalgia into modern, eye-catching products.
            <br /><br />
            My team of four was given the task of creating a game that would
            increase user engagement and drive more traffic to the website.
          </p>

          <div className="hero-tags">
            <span>Gamification</span>
            <span>UX Design</span>
            <span>Visual Design</span>
          </div>

          <button
            className="primary-cta"
            type="button"
            onClick={() => window.open("https://husmanspel.se/", "_blank")}
          >
            Play the live game
          </button>
        </div>

        <div className="husman-hero-image">
          <div className="hero-mockup-frame">
            <img src={Mockup7} alt="Fikapet game app mockup" />
          </div>
        </div>
      </section>

      {/* ================= DESIGN SOLUTION ================= */}
      <section className="project-section reveal">
        <h2>Design solution</h2>
        <p className="large-text">
          The game is based on collecting points in the form of saffron buns while
          avoiding obstacles such as trees and moose. By reaching a certain number
          of points, players receive a discount code for the Svensk Husman website,
          and they can also compete with others by climbing the leaderboard.
        </p>
      </section>

      {/* ================= JOURNEY ================= */}
      <section className="project-section reveal">
        <h2>The Journey</h2>

        <div className="columns-3">
          <div className="journey-card">
            <h3>User Research</h3>
            <p>
              We began by researching existing games and identifying which type of
              gamification would be most effective for engaging users in this
              project. We also studied Svensk Husman’s brand to understand what
              kind of design direction the game should follow.
            </p>
          </div>

          <div className="journey-card">
            <h3>Idea Generation</h3>
            <p>
              We brainstormed several different concepts to determine what kind of
              game would work best. We created surveys to understand which type of
              gamification users preferred, then developed mid-fi prototypes that we
              tested before moving on to the final design.
            </p>
          </div>

          <div className="journey-card">
            <h3>Final Prototype</h3>
            <p>
              We refined the mid-fi prototype into a fully polished high-fidelity
              design aligned with Svensk Husman’s visual identity. User testing
              helped ensure a smooth and intuitive experience throughout the game.
            </p>
          </div>
        </div>
      </section>

      {/* ================= DESKTOP MOCKUPS ================= */}
      <section className="image-row reveal">
        <img src={Dator1} alt="Desktop view of Svensk Husman game" />
        <img src={Dator2} alt="Desktop leaderboard and game screen" />
      </section>

      {/* ================= VISUALS ================= */}
      <section className="project-section reveal">
        <h2>Visuals</h2>
        <p className="large-text">
          The visual language is playful yet clean, combining pixel-art inspired
          trees with bold, rounded typography and a warm winter palette that feels
          both nostalgic and modern.
        </p>
      </section>

      <section className="image-row-3 reveal">
        <img src={Mockup1} alt="Game start screen visual design" />
        <img src={Mockup2} alt="In-game view with obstacles and buns" />
        <img src={Mockup3} alt="Result screen from the game" />
      </section>

      <section className="image-row-4 reveal">
        <img src={Mockup4} alt="Tree illustration" />
        <img src={Mockup6} alt="Character illustration" />
        <img src={Mockup5} alt="Large saffron bun illustration" />
      </section>

    </main>
  );
}

